import React from "react";
import { Key } from "react-aria";
import { c, t } from "ttag";

import {
    ServerCmsModelsPagesDownloadLibraryPageAutocompleteEntry as AutocompleteEntry,
    ServerCmsModelsPagesDownloadLibraryPageBreadcrumb as Breadcrumb,
} from "@reactivated";

import { ButtonSecondary } from "../Clickables";
import { AutocompleteField } from "../Forms/Autocomplete";

import styles from "./index.module.scss";

export const DownloadLibraryNav = (props: {
    autocomplete: AutocompleteEntry[];
    breadcrumbs: Breadcrumb[];
}) => {
    const handleSelectionChange = (key: Key | null) => {
        if (!key) return;
        window.location.href = key.toString();
    };

    return (
        <nav className={styles.nav}>
            <div>
                <h2 className={styles.title}>{t`Browse`}</h2>
                <ul className={styles.breadcrumbs}>
                    {props.breadcrumbs.map((page) => (
                        <li key={page.url}>
                            {page.url ? (
                                <ButtonSecondary href={page.url}>
                                    {page.title}
                                </ButtonSecondary>
                            ) : (
                                <span>{page.title}</span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
            <AutocompleteField
                label={t`Search by product name or #`}
                labelVisible={false}
                items={props.autocomplete}
                itemKey="url"
                itemFormatter={(entry) =>
                    c("DownloadLibrary").t`${entry.sku}: ${entry.title}`
                }
                onSelectionChange={handleSelectionChange}
                placeholder={t`Search by product name or #`}
                className={styles.input}
            />
        </nav>
    );
};
